import { render, staticRenderFns } from "./Web_katsumatatire.vue?vue&type=template&id=30a96d74&scoped=true&"
import script from "./Web_katsumatatire.vue?vue&type=script&lang=js&"
export * from "./Web_katsumatatire.vue?vue&type=script&lang=js&"
import style0 from "./Web_katsumatatire.vue?vue&type=style&index=0&id=30a96d74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a96d74",
  null
  
)

export default component.exports